import { Directive, forwardRef, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS } from '@angular/forms';

@Directive({
    selector: '[mustHaveUpercase]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => MustHaveUpercaseDirective),
            multi: true,
        },
    ],
    standalone: false
})
export class MustHaveUpercaseDirective {
  @Input('mustHaveUpercase') validationNeeded: boolean;

  validator: Function;

  constructor() {
    this.validator = validateUpercase;
  }

  validate(control: UntypedFormControl) {
    return this.validationNeeded ? this.validator(control) : null;
  }
}

export function validateUpercase(control: UntypedFormControl) {
  let UPERCASE_REGEX = new RegExp(/[A-Z]/);

  return UPERCASE_REGEX.test(control.value)
    ? null
    : {
        mustHaveUpercase: true,
      };
}
